import { Button } from "@instacover/ui"
import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { BaseLayout } from "@/components/layouts/BaseLayout"
import { SpinnerLayout } from "@/components/layouts/SpinnerLayout"
import { useFinishStepAndNavigate } from "@/routing/useStepsRouting"
import { AddDamageButton } from "@/sections/claim/overview/AddDamageButton"
import { ClaimMarkerList } from "@/sections/claim/overview/ClaimMarkerList"
import { useClaimMarkersBySession } from "@/services/dexie"

export const Route = createFileRoute("/$sessionId/_session/claim/overview")({
  component: ClaimOverviewPage,
})

function ClaimOverviewPage() {
  const { t } = useTranslation()
  const { sessionId } = Route.useParams()
  const finishAndNavigate = useFinishStepAndNavigate(sessionId)

  const { data: markers, isLoading } = useClaimMarkersBySession(sessionId)
  const markerList = markers ?? []

  if (isLoading) {
    return <SpinnerLayout />
  }

  return (
    <BaseLayout dataTestId="claim-overview">
      <div className="h-vh-header mx-auto flex max-w-2xl flex-col pt-8 pb-6">
        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="mx-6">
            <h1 className="text-ic-heading text-2xl font-bold">{t("claim.overview.heading")}</h1>
            <p className="text-ic-text mt-4 text-base">{t("claim.overview.description")}</p>
          </div>

          <ClaimMarkerList sessionId={sessionId} markers={markerList} />
        </div>

        <div className="mx-6 mt-6 flex shrink-0 flex-col gap-3">
          <Button
            onClick={() => finishAndNavigate("Claim")}
            disabled={markerList.length === 0}
            data-testid="claim-overview-continue-btn"
          >
            {t("claim.overview.continueButton")}
          </Button>

          <AddDamageButton sessionId={sessionId} markers={markerList} />
        </div>
      </div>
    </BaseLayout>
  )
}
